import { render, staticRenderFns } from "./ReductionReportContent.vue?vue&type=template&id=28d43ed4"
import script from "./ReductionReportContent.vue?vue&type=script&lang=js"
export * from "./ReductionReportContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports